import React from 'react'
import { Link } from 'react-router-dom'

const AboutPage = () => {
  return (
    <>
    <div>About Page</div>
    <Link to='/'>Back home</Link>
    </>
  )
}

export default AboutPage